import { NotificationService } from 'src/app/shared/services/notification.service';
import { map as rxjsmap } from 'rxjs';
import { inject, Component, OnInit, EventEmitter } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ValidationService } from 'src/app/kuba/shared/services/validation.service';

import { SelectItem } from 'primeng/api';
import { environment } from 'src/environments/environment';
import { BaseServices } from './../../kuba.services';

import { TranslateService } from '@ngx-translate/core';
import { SettingsMeta } from './../models/business-setting-add';
import { BusinessSettingService } from './../services/businessSetting.service';
import {
  UploadInput,
  UploadFile,
  humanizeBytes,
  UploaderOptions
} from '../../../_models/primeng-uploads';
import { Application } from 'src/app/_models';
import { HttpClient } from '@angular/common/http';
import { ConfirmationService } from 'primeng/api';
import { forkJoin, Observable, of, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { BusinessSettingViewDto } from '../models/business-setting.models';
import { User } from '../models';
import { UserService } from '../../users/services/user.service';
import { BusinessServices } from '../services/business.services';
import { Roles, FeatureKey, Status } from 'src/app/_models/feature';
import { Feature } from '../../features/models/features-base.model';
import {
  SdsApiService,
  SdsEligibleEditor,
  SdsExposureAccessDto
} from '../../safety-data-sheet/services/sds-api.service';
import { FlexiAdvisorSettingsService } from '../../flexi/advisor-settings/flexi-advisor-settings.service';
import { FlexiBusinessAdvisor } from '../../flexi/advisor-settings/flexi-advisor-settings.models';

export class Emp {
  chkEmployee = false;
  chkMainSafetyDelegate = false;
  chkSafetyDelegate = false;
  chkEmployeeDelegate = false;
  chkFireDelegate = false;
  chkAccountant = false;
  chkAuditor = false;
  chkEnv = true;
  chkCompensationInsurance = false;
  chkStatutoryInsurance = false;
  chkOccupational = false;
  chkpersonal = false;
  chkemployment = false;
  constructor() {}
}

@Component({
  selector: 'business-settings',
  templateUrl: 'business-settings.component.html',
  styleUrls: ['business-settings.component.css'],
  providers: [BusinessSettingService],
  standalone: false
})
export class BusinessSettingsComponent implements OnInit {
  //#region variables
  private readonly notifications = inject(NotificationService);
  private readonly usersService = inject(UserService);
  private readonly businessesService = inject(BusinessServices);
  showPersonDialog = false;
  createPersonWithLogin = false;
  refreshingPeople = false;
  peopleRefreshFailed = false;
  private savedSettingsSnapshot = '';
  businessSetting: FormGroup;
  Language: SelectItem[];
  Employee: SelectItem[];
  MultipleEmployee: SelectItem[];
  OnlyEmployee: SelectItem[];
  businessId: number;
  bId: any;
  Theme: SelectItem[];
  selectedEmployee: any;
  selectedOccupational: any;
  selectedPersonal: number;
  selectedMainSafetyDelegate: any = [];
  selectedSafetyDelegate: any = [];
  selectedEmployeeDelegate: any = [];
  selectedFireDelegate: number;
  selectedAccountant: number;
  selectedAuditor: number;
  selectedEnv: number;
  selectedEmployeeInsurance: any;
  InsuranceCompany: string;
  HomePageAddress: string;
  public selectedLanguage: number;
  selectedTheme: number;
  selectedValues: any;
  employee: any;
  employeeonly: any;
  language: any;
  setting: any;
  theme: any;
  chkEmployee = false;
  chkOccupational = false;
  chkpersonal = false;
  chkemployment = false;
  emp = new Emp();
  uploadedFiles: any[] = [];
  value: number;
  settingId: number;
  selectedHseManager: any;
  selectedEnvLighthosue: any;
  selectedPortalContact: any;
  HseGoals: any;
  HseManager: SelectItem[];
  EnvLight: SelectItem[];
  Sms: Boolean;
  Email: Boolean;
  businessLogoUpload: any;
  businessLogo: string;
  businessImage: string;
  file: any;
  PortalContact: SelectItem[];
  isEditBusiness = false;
  isFileChoosed = false;
  files: UploadFile[];
  uploadInput: EventEmitter<UploadInput>;
  uploadInputForImage: EventEmitter<UploadInput>;
  humanizeBytes: Function;
  dragOver: boolean;
  options: UploaderOptions;
  optionForImage: UploaderOptions;
  selectedFiles: any;
  loading: boolean;
  uploadStart: boolean;
  uploadStartForLogo: boolean;
  siteAddress: FormGroup;
  isPortalBusiness: boolean;
  loadingReport = false;
  EmployeeContact: SelectItem[];
  employeeContact: any;
  HavePersonalDelegateOptions: SelectItem[];
  isDinHMSLogin = false;
  uploadExtions = ['image/png', 'image/jpeg', 'image/gif'];
  isShowBusinessLanguage: boolean;
  private subscriptions: Subscription[] = [];
  /**
   * The business's HSE advisors in priority order, read-only here: they are
   * managed in Admin mode › Flexi › Settings, so there is one place to change
   * them. Shown to everyone who can open business settings.
   */
  hseAdvisors: FlexiBusinessAdvisor[] = [];
  hseAdvisorsFailed = false;
  /**
   * Admin mode only — Flexi › Settings is refused inside R-mode, where roleId
   * reads '3', so the link is not offered there.
   */
  readonly canManageHseAdvisors = BaseServices.roleId === '1';
  readonly flexiSettingsLink = ['/app/admin', BaseServices.ApplicationId, 'Flexi', 'settings'];
  isAdmin: boolean = false;
  selectedEmpInsurance: boolean = true;
  selectedEmpstatutory: boolean = true;
  selectedEmpOccupational: boolean = true;
  usersByBusiness: User[] = [];
  UsersByBusinessSelect: SelectItem[] = [];
  CustomerActionPointResponsibleSelect: SelectItem[] = [];
  selectedResponsibleForExecution: number[] = [];
  selectedResponsibleForFollowup: number[] = [];
  selectedFlexiCustomerActionPointResponsibleUserIds: number[] = [];
  noResponsibleCandidates = false;
  noCustomerActionPointResponsibleCandidates = false;

  // Appraisal variables
  managerDropdown: SelectItem[] = [];
  selectedResponsibleForAppraisals: number[] = [];
  currentResponsibleForAppraisals: number[] = [];
  hasAppraisalModule = false;
  canEditFlexiCustomerActionPointResponsible = false;
  hasSafetyDataSheetsModule = false;
  hasContactsModule = false;
  sdsExposureEditorDropdown: SelectItem[] = [];
  selectedSdsExposureEditorIds: number[] = [];
  currentSdsExposureEditorIds: number[] = [];
  isSdsExposureAccessLoading = false;
  sdsExposureAccessError: string | null = null;
  //#endregion

  //#region constructors
  /**
   * constructor
   * @param businessSettingService {BusinessSettingService}
   * @param activatedRoute {ActivatedRoute}
   * @param _fb {FormBuilder}
   */
  constructor(
    private businessSettingService: BusinessSettingService,
    private activatedRoute: ActivatedRoute,
    private _fb: FormBuilder,
    private http: HttpClient,
    private translate: TranslateService,
    private confirmationService: ConfirmationService,
    private sdsApiService: SdsApiService,
    private flexiAdvisors: FlexiAdvisorSettingsService
  ) {
    this.isPortalBusiness = this.activatedRoute.snapshot.data['portalbusiness'];
    this.options = {
      concurrency: 1,
      allowedContentTypes: ['image/png', 'image/jpeg', 'image/gif']
    };
    this.optionForImage = {
      concurrency: 1,
      allowedContentTypes: ['image/png', 'image/jpeg', 'image/gif']
    };
    this.files = [];
    this.humanizeBytes = humanizeBytes;
  }
  //#endregion

  //#region page-events
  /**
   * page load event,get business setting data for edit and bind drodowns
   */
  ngOnInit() {
    document.querySelector('body').classList.remove('opened');
    if (
      BaseServices.ApplicationId === Application.DIN_HMS ||
      BaseServices.ApplicationId === Application.IK
    ) {
      this.isDinHMSLogin = true;
    }
    // AbsoluteroleId is the REAL role: roleId reports '3' (editor) in R-mode,
    // and an Admin acting in a business keeps admin rights here.
    const isAdmin = String(BaseServices.AbsoluteroleId) === '1';
    // The Flexi action-point responsible ("BHT-ansvarlig for tiltak") is the
    // customer's own choice of which of their users owns action points, so
    // Editors set it too — they are the customer-side administrator, and
    // requiring a Kuba admin for it made the business dependent on us for its
    // own staffing. Admin keeps access (also in R-mode, per AbsoluteroleId).
    // Guest/User remain read-only.
    //
    // The BE already accepts this: PUT /business/settings is
    // Admin_Portal_Editor, so no server change was needed to allow the save.
    this.canEditFlexiCustomerActionPointResponsible =
      isAdmin || String(BaseServices.AbsoluteroleId) === String(Roles.EDITOR);
    this.isAdmin = BaseServices.roleId == '1';
    this.bindDropDowns();

    this.checkBusinessModules();

    this.businessSetting = this._fb.group({
      safetyDelegate: ['', [Validators.required]],
      employeeDelegate: ['', [Validators.required]],
      fireDelegate: ['', [Validators.required]],
      accountant: ['', [Validators.required]],
      auditor: ['', [Validators.required]],
      employeeInsurance: ['', [Validators.required]],
      employee: ['', [Validators.required]]
    });
    this.siteAddress = this._fb.group({
      homeSiteAddress: ['', ValidationService.websiteValidator]
    });

    this.businessLogoUpload =
      environment.BASE_URL +
      '/file/upload/business/logo/' +
      BaseServices.ApplicationId +
      '/' +
      this.businessId;
    this.subscriptions.push(
      this.activatedRoute.parent.params.subscribe((params: Params) => {
        let bid = params['bid'];
        if (this.businessId !== +bid) this.showPersonDialog = false;
        this.businessId = +bid;
        if (this.businessId) {
          this.loadHseAdvisors();
          this.businessLogoUpload = `${environment.BASE_URL}
                                            /file/upload/business/logo/
                                            ${BaseServices.ApplicationId}/${this.businessId}`;

          const businessSetting: BusinessSettingViewDto =
            this.activatedRoute.snapshot.data['setting'];
          const usersByBusiness: User[] | null | undefined =
            this.activatedRoute.snapshot.data['usersByBusiness'];

          const safeUsers: User[] = Array.isArray(usersByBusiness)
            ? usersByBusiness
            : [];

          this.usersByBusiness = safeUsers;

          this.UsersByBusinessSelect = safeUsers.map(u => ({
            label: u.Name,
            value: u.Id
          }));
          this.CustomerActionPointResponsibleSelect = safeUsers
            .filter(u => u.Status === Status.Active && u.RoleId === Roles.EDITOR && u.BusinessId === this.businessId)
            .map(u => ({
              label: u.Name,
              value: u.Id
            }));

          this.selectedResponsibleForExecution =
            businessSetting?.ResponsibleForExecution ?? [];
          this.selectedResponsibleForFollowup =
            businessSetting?.ResponsibleForFollowup ?? [];
          this.selectedFlexiCustomerActionPointResponsibleUserIds =
            businessSetting?.FlexiCustomerActionPointResponsibleUserIds ??
            (businessSetting?.FlexiCustomerActionPointResponsibleUserId ? [businessSetting.FlexiCustomerActionPointResponsibleUserId] : []);
          this.selectedResponsibleForAppraisals =
            businessSetting?.ResponsibleForAppraisal ?? [];
          this.currentResponsibleForAppraisals = structuredClone(
            this.selectedResponsibleForAppraisals
          );

          this.noResponsibleCandidates = safeUsers.length === 0;
          this.noCustomerActionPointResponsibleCandidates =
            this.CustomerActionPointResponsibleSelect.length === 0;

          if (businessSetting) {
            this.HseGoals = businessSetting.HseGoal;
            this.settingId = businessSetting.Id;
            this.assignCheckBoxes(
              businessSetting.SettingsMeta ? businessSetting.SettingsMeta : []
            );
            this.selectedLanguage = businessSetting.LanguageId;
            this.InsuranceCompany = businessSetting.InsuranceCompany;
            this.selectedHseManager = businessSetting.HseManagerKey;
            this.selectedEnvLighthosue =
              businessSetting.EnvironmentallighthouseKey;
            this.businessLogo = businessSetting.BusinessLogo;
            this.businessImage = businessSetting.BusinessImg;
            this.selectedPortalContact = businessSetting.PortalContact;
            let address = {
              homeSiteAddress: businessSetting.HomePageAddress
                ? businessSetting.HomePageAddress
                : 'http://'
            };
            (<FormGroup>this.siteAddress).setValue(address, { onlySelf: true });
          } else {
            this.selectedLanguage = 2;
            (<FormGroup>this.siteAddress).setValue(
              {
                homeSiteAddress: 'http://'
              },
              { onlySelf: true }
            );
          }

          this.loadSdsExposureAccess();
          this.savedSettingsSnapshot = this.captureSettingsSnapshot();
        }
      })
    );

    this.bindManagerDropdown();
    this.savedSettingsSnapshot = this.captureSettingsSnapshot();

    if (this.settingId) {
      if (this.settingId > 0) {
        this.isEditBusiness = true;
      }
    }

    if (BaseServices.ApplicationId == 5) {
      this.isShowBusinessLanguage = false;
    } else {
      this.isShowBusinessLanguage = true;
    }

    if (BaseServices.ApplicationId == 5) {
      this.isShowBusinessLanguage = false;
    } else {
      this.isShowBusinessLanguage = true;
    }
  }

  //#endregion

  //#region control-events

  /**
   * Removes duplicate entries from the arrays `selectedResponsibleForExecution`
   * and `selectedResponsibleForFollowup` to ensure unique values.
   */
  private normalizeResponsibles() {
    this.selectedResponsibleForExecution = [
      ...new Set(this.selectedResponsibleForExecution)
    ];
    this.selectedResponsibleForFollowup = [
      ...new Set(this.selectedResponsibleForFollowup)
    ];
  }

  /**
   * Generates a summary string for the selected IDs based on the provided options.
   *
   * @param {number[]} selectedIds - An array of selected IDs.
   * @param {SelectItem[]} options - An array of options containing `label` and `value` pairs.
   * @returns {string} - A summary string that includes the label of the first selected ID
   *                     and the count of additional selected IDs (if any).
   *                     Returns an empty string if no IDs are selected.
   */
  getSummary(selectedIds: number[], options: SelectItem[]): string {
    if (!selectedIds || selectedIds.length === 0) return '';
    const labelsById = new Map(
      options.map(o => [o.value, o.label] as [number, string])
    );
    const first = labelsById.get(selectedIds[0]) ?? '';
    const extra = selectedIds.length - 1;
    return extra > 0 ? `${first} +${extra}` : first;
  }

  get showSdsExposureAccessSettings(): boolean {
    return this.isAdmin && this.hasSafetyDataSheetsModule;
  }

  /**
   * The Accountant and Auditor settings are only usable when the business has the
   * Contacts module, since both may only be filled with registered contacts.
   */
  get canSelectExternalServicePerson(): boolean {
    return this.hasContactsModule;
  }

  get canCreateSettingsPerson(): boolean {
    return String(BaseServices.AbsoluteroleId) === '1' && this.businessId > 0;
  }

  get hasUnsavedSettings(): boolean {
    return this.savedSettingsSnapshot !== this.captureSettingsSnapshot() ||
      JSON.stringify(this.selectedSdsExposureEditorIds) !== JSON.stringify(this.currentSdsExposureEditorIds);
  }

  private captureSettingsSnapshot(): string {
    const fields = [
      'selectedMainSafetyDelegate', 'selectedSafetyDelegate', 'selectedEmployeeDelegate',
      'selectedFireDelegate', 'selectedAccountant', 'selectedAuditor', 'selectedEmployeeInsurance',
      'selectedEmployee', 'selectedOccupational', 'selectedPersonal', 'HseGoals', 'selectedLanguage',
      'selectedHseManager', 'selectedEnvLighthosue', 'InsuranceCompany',
      'selectedFlexiCustomerActionPointResponsibleUserIds', 'selectedResponsibleForExecution',
      'selectedResponsibleForFollowup', 'selectedResponsibleForAppraisals', 'businessLogo', 'businessImage'
    ] as const;
    return JSON.stringify([this.emp, fields.map(field => this[field]), this.siteAddress?.getRawValue()]);
  }

  get settingsBusinessName(): string {
    return this.activatedRoute.snapshot.data['businessDetails']?.CompanyName ?? '';
  }

  get settingsApplicationId(): number {
    return this.activatedRoute.snapshot.data['businessDetails']?.ApplicationId ?? BaseServices.ApplicationId;
  }

  openPersonDialog(withLogin: boolean): void {
    if (!this.canCreateSettingsPerson) return;
    this.createPersonWithLogin = withLogin;
    this.showPersonDialog = true;
  }

  refreshPeopleOptions(): void {
    if (!this.canCreateSettingsPerson || this.refreshingPeople) return;
    this.refreshingPeople = true;
    this.peopleRefreshFailed = false;
    this.subscriptions.push(forkJoin({
      users: this.businessesService.getUsersByBusiness(this.businessId),
      employees: this.usersService.getEmployeeOnly(this.businessId),
      contacts: this.businessesService.getContactsByBusiness(this.businessId),
      people: this.usersService.getEmployeeContactUsers(this.businessId),
      personalDelegates: this.businessesService.getHpdOptions(this.businessId)
    }).subscribe({
      next: result => {
        const options = (people: { Id: number; Name: string }[]): SelectItem[] =>
          (Array.isArray(people) ? people : []).map(person => ({ label: person.Name, value: person.Id }));
        this.OnlyEmployee = options(result.employees);
        this.EmployeeContact = options(result.contacts);
        this.HseManager = options(result.people);
        this.EnvLight = options(result.people);
        this.HavePersonalDelegateOptions = options(result.personalDelegates);
        this.usersByBusiness = Array.isArray(result.users) ? result.users : [];
        this.UsersByBusinessSelect = options(this.usersByBusiness);
        this.CustomerActionPointResponsibleSelect = options(this.usersByBusiness.filter(user =>
          user.Status === Status.Active && user.RoleId === Roles.EDITOR && user.BusinessId === this.businessId));
        this.managerDropdown = options(this.usersByBusiness.filter(user =>
          user.RoleId === Roles.EDITOR && user.FeatureId === FeatureKey.EMPLOYEES && user.Status === Status.Active));
        this.noResponsibleCandidates = this.UsersByBusinessSelect.length === 0;
        this.noCustomerActionPointResponsibleCandidates = this.CustomerActionPointResponsibleSelect.length === 0;
        this.refreshingPeople = false;
        // Refresh eligibility only: reloading saved access would discard unsaved assignments.
        if (this.showSdsExposureAccessSettings) {
          this.subscriptions.push(this.sdsApiService.getEligibleEditors(this.businessId).subscribe({
            next: editors => { this.sdsExposureEditorDropdown = editors.map(editor => ({ label: editor.Name || editor.Email, value: editor.UserId })); },
            error: () => { this.peopleRefreshFailed = true; }
          }));
        }
      },
      error: () => { this.refreshingPeople = false; this.peopleRefreshFailed = true; }
    }));
  }

  get noSdsExposureEditorCandidates(): boolean {
    return this.sdsExposureEditorDropdown.length === 0;
  }

  private loadSdsExposureAccess(): void {
    if (!this.showSdsExposureAccessSettings || !this.businessId) {
      this.sdsExposureEditorDropdown = [];
      this.selectedSdsExposureEditorIds = [];
      this.currentSdsExposureEditorIds = [];
      return;
    }

    this.isSdsExposureAccessLoading = true;
    this.sdsExposureAccessError = null;

    this.subscriptions.push(
      forkJoin([
        this.sdsApiService.getEligibleEditors(this.businessId),
        this.sdsApiService.getExposureAccess(this.businessId)
      ]).subscribe(
        ([editors, access]: [SdsEligibleEditor[], SdsExposureAccessDto]) => {
          this.sdsExposureEditorDropdown = (editors || []).map(editor => ({
            label: editor.Name || editor.Email || `Editor ${editor.UserId}`,
            value: editor.UserId
          }));
          this.applySdsExposureAccess(access);
          this.isSdsExposureAccessLoading = false;
        },
        () => {
          this.sdsExposureAccessError = this.translate.instant(
            'SDS_EXPOSURE_EDITOR_ACCESS_LOAD_ERROR'
          );
          this.isSdsExposureAccessLoading = false;
        }
      )
    );
  }

  private applySdsExposureAccess(access: SdsExposureAccessDto | null): void {
    const allowedIds = (access?.AllowedEditors || []).map(
      editor => editor.UserId
    );
    this.selectedSdsExposureEditorIds = [...new Set(allowedIds)];
    this.currentSdsExposureEditorIds = structuredClone(
      this.selectedSdsExposureEditorIds
    );
  }

  private saveSdsExposureAccessIfNeeded(): Observable<SdsExposureAccessDto | null> {
    if (!this.showSdsExposureAccessSettings || !this.businessId) {
      return of(null);
    }

    const allowedIds = [...new Set(this.selectedSdsExposureEditorIds || [])];
    this.sdsExposureAccessError = null;
    return this.sdsApiService
      .setExposureAccess(this.businessId, allowedIds)
      .pipe(
        map(access => {
          this.applySdsExposureAccess(access);
          return access;
        })
      );
  }

  /**
   * print this page event
   */
  exportPdf() {
    this.loadingReport = true;
    let fileName = this.translate.instant('BUSINESS_DETAIL');
    let filetype = 'pdf';
    let type = 2;
    let cultureInfo = sessionStorage.getItem('languageMode')!;
    let ReportJson = this.activatedRoute.parent?.snapshot.data['detail'];
    ReportJson.BusinessId = this.activatedRoute.parent.params['bid'];
    let buId: any = this.activatedRoute.snapshot.parent?.params['bid'];
    ReportJson.BusinessId = buId;
    this.subscriptions.push(
      this.businessSettingService
        .reportGenerate(
          +this.activatedRoute.snapshot.parent.params['bid'],
          type,
          cultureInfo,
          ReportJson,
          BaseServices.ApplicationId
        )
        .subscribe(
          (blob: any) => {
            this.loadingReport = false;
            let link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = `${fileName}.${filetype.toLowerCase()}`;
            link.click();
          },
          (error: any) => {
            this.loadingReport = false;
            
          }
        )
    );
  }

  /**
   * print all page event
   */
  exportallPdf() {
    this.loadingReport = true;
    let fileName = this.translate.instant('BUSINESS_DETAIL');
    let filetype = 'pdf';
    let type = 3;
    let cultureInfo = sessionStorage.getItem('languageMode')!;
    let list = this.activatedRoute.parent?.snapshot.data['employeeCount'];
    let employeeCount = list.filter((x: any) => x.Status === 1);
    let ReportJson = this.activatedRoute.parent?.snapshot.data['detail'];
    ReportJson.EmployeeCount = employeeCount.length;
    ReportJson.BusinessId = this.activatedRoute.snapshot.parent.params['bid'];
    this.subscriptions.push(
      this.businessSettingService
        .reportGenerate(
          +this.activatedRoute.snapshot.parent.params['bid'],
          type,
          cultureInfo,
          ReportJson,
          BaseServices.ApplicationId
        )
        .subscribe(
          (blob: any) => {
            this.loadingReport = false;
            let link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = `${fileName}.${filetype.toLowerCase()}`;
            link.click();
          },
          (error: any) => {
            this.loadingReport = false;
            
          }
        )
    );
  }

  /**
   * upload for business logo
   * @param selectedFiles
   */
  filesSelectForLogo(selectedFiles: any) {
    this.uploadStartForLogo = true;
    this.selectedFiles = Array.from(selectedFiles.currentTarget.files).map(
      file => file
    );
    let formData = new FormData();
    formData.append('file', this.selectedFiles[0]);

    this.subscriptions.push(
      this.http
        .post(
          environment.BASE_URL +
            '/file/upload/business/logo/' +
            BaseServices.ApplicationId +
            '/' +
            this.businessId,
          formData
        ).pipe(rxjsmap((response: any) => {
          this.uploadStartForLogo = false;
          let res = response;
          this.businessLogo = res.path;
          this.loading = false;
        }))
        .subscribe(
          result => {},
          error => console.log('Upload article Sign Error : ', error),
          () => console.log('Upload article  Sign Complete')
        )
    );
  }

  /**
   * upload for business image
   * @param selectedFiles
   */
  filesSelect(selectedFiles: any): void {
    this.uploadStart = true;
    this.selectedFiles = Array.from(selectedFiles.currentTarget.files).map(
      file => file
    );
    let formData = new FormData();
    formData.append('file', this.selectedFiles[0]);

    this.subscriptions.push(
      this.http
        .post(
          environment.BASE_URL +
            '/file/upload/business/logo/' +
            BaseServices.ApplicationId +
            '/' +
            this.businessId,
          formData
        ).pipe(rxjsmap((response: any) => {
          this.uploadStart = false;
          let res = response;
          this.businessImage = res.path;
          this.loading = false;
        }))
        .subscribe(
          result => {},
          error => console.log('Upload article Sign Error : ', error),
          () => console.log('Upload article  Sign Complete')
        )
    );
  }

  /**
   * cancel upload
   * @param id
   */
  cancelUpload(id: string): void {
    this.uploadInput.emit({ type: 'cancel', id: id });
  }

  /**
   * removing uploaded file
   * @param id
   */
  removeFile(id: string): void {
    this.uploadInput.emit({ type: 'remove', id: id });
  }

  removeAllFiles(): void {
    this.uploadInput.emit({ type: 'removeAll' });
  }
  //#endregion

  //#region methods
  /**
   * binding dropdowns
   */
  bindDropDowns() {
    this.MultipleEmployee = [{ label: '', value: '' }];
    this.employee = this.activatedRoute.snapshot.data['user'];
    this.subscriptions.push(
      this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
        this.MultipleEmployee = this.MultipleEmployee.map(option =>
          option.value === '' ? { ...option, label: val.SELECT } : option
        );
      })
    );
    if (this.employee) {
      this.employee.forEach((element: any) => {
        this.MultipleEmployee.push({
          label: element.Name,
          value: element.Id
        });
      });
    }
    this.employeeonly = this.activatedRoute.snapshot.data['EmployeeOnly'];
    this.OnlyEmployee = [{ label: '', value: '' }];
    this.subscriptions.push(
      this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
        // Translate only the placeholder, retaining people added while editing.
        this.OnlyEmployee = this.OnlyEmployee.map(option =>
          option.value === '' ? { ...option, label: val.SELECT } : option
        );
      })
    );
    if (this.employeeonly) {
      this.employeeonly.forEach((element: any) => {
        this.OnlyEmployee.push({
          label: element.Name,
          value: element.Id
        });
      });
    }

    this.Employee = [{ label: '', value: '' }];
    this.employee = this.activatedRoute.snapshot.data['user'];
    this.subscriptions.push(
      this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
        this.Employee = this.Employee.map(option =>
          option.value === '' ? { ...option, label: val.SELECT } : option
        );
      })
    );
    if (this.employee) {
      this.employee.forEach((element: any) => {
        this.Employee.push({
          label: element.Name,
          value: element.Id
        });
      });
    }

    this.employeeContact = this.activatedRoute.snapshot.data['employeeContact'];
    this.EmployeeContact = [];

    if (this.employeeContact) {
      this.employeeContact.forEach((element: any) => {
        this.EmployeeContact.push({
          label: element.Name,
          value: element.Id
        });
      });
    }

    let HPDOptions =
      this.activatedRoute.snapshot.data['havePersonalDelegateOptions'];
    this.HavePersonalDelegateOptions = [];
    this.HavePersonalDelegateOptions.push({ label: 'Select', value: null });
    if (HPDOptions) {
      HPDOptions.forEach((element: any) => {
        this.HavePersonalDelegateOptions.push({
          label: element.Name,
          value: element.Id
        });
      });
    }

    this.Language = [];
    this.language = this.activatedRoute.snapshot.data['language'];
    this.Language = [];
    this.Language.push({ label: 'Select', value: null });

    if (this.language) {
      this.language.forEach((element: any) => {
        this.Language.push({ label: element.Title, value: element.Id });
      });
    }

    let manager = this.activatedRoute.snapshot.data['user'];
    this.HseManager = [];
    this.HseManager.push({ label: 'Select', value: null });
    if (manager) {
      manager.forEach((element: any) => {
        this.HseManager.push({ label: element.Name, value: element.Id });
      });
    }

    let manager1 = this.activatedRoute.snapshot.data['user'];

    this.EnvLight = [];
    this.EnvLight.push({ label: 'Select', value: null });
    if (manager1) {
      manager1.forEach((element: any) => {
        this.EnvLight.push({ label: element.Name, value: element.Id });
      });
    }
    let portal = this.activatedRoute.snapshot.data['portalcontact'];
    this.PortalContact = [];
    this.PortalContact.push({ label: 'Select', value: null });

    if (portal) {
      portal.forEach((element: any) => {
        this.PortalContact.push({ label: element.Name, value: element.Id });
      });
    }
  }

  /**
   * Checks if the business has Settings-controlled modules activated.
   */
  checkBusinessModules() {
    const businessDetails =
      this.activatedRoute.snapshot.data['businessDetails'];

    if (!businessDetails) {
      return;
    }

    const featureString = businessDetails.Features;
    if (!featureString) return;
    const features: Feature[] = JSON.parse(featureString);
    if (!features) return;

    const employeeFeatures = features.find(x => x.id == FeatureKey.EMPLOYEES);
    const dialogMeetingsFeature: Feature | null =
      employeeFeatures?.children?.find(
        x => x.id == FeatureKey.EMPLOYEE_DIALOG_MEETINGS
      ) ?? null;

    if (dialogMeetingsFeature !== null && dialogMeetingsFeature.checked) {
      this.hasAppraisalModule = true;
    }

    const sdsFeature = this.findFeature(
      features,
      FeatureKey.SAFETY_DATA_SHEETS
    );
    const sdsProductFeature = this.findFeature(
      features,
      FeatureKey.SDS_PRODUCT_INFORMATION
    );
    this.hasSafetyDataSheetsModule =
      sdsFeature?.checked === true || sdsProductFeature?.checked === true;

    this.hasContactsModule =
      this.findFeature(features, FeatureKey.CONTACTS)?.checked === true;
  }

  private findFeature(
    features: Feature[] | undefined,
    featureId: FeatureKey
  ): Feature | null {
    for (const feature of features || []) {
      if (feature.id === featureId) {
        return feature;
      }

      const childFeature = this.findFeature(
        (feature as any).children as Feature[] | undefined,
        featureId
      );
      if (childFeature) {
        return childFeature;
      }
    }

    return null;
  }

  /**
   * bind manager dropdown, selects only employees with EDITOR role
   */
  bindManagerDropdown() {
    this.managerDropdown = [];
    const users = this.activatedRoute.snapshot.data['usersByBusiness'];
    if (users) {
      users
        .filter(
          (element: User) =>
            element.RoleId === Roles.EDITOR &&
            element.FeatureId === FeatureKey.EMPLOYEES &&
            element.Status === Status.Active
        )
        .forEach((element: User) => {
          this.managerDropdown.push({ label: element.Name, value: element.Id });
        });
    }
  }

  /**
   * assign checkbox values
   * @param settingMetas
   */
  assignCheckBoxes(settingMetas: any) {
    settingMetas.forEach((meta: any) => {
      if (meta.BusinessMetadataId === 1) {
        this.emp.chkEmployee = true;
      }
      if (meta.BusinessMetadataId === 10) {
        this.emp.chkOccupational = true;
        this.selectedOccupational = meta.HealthCare;
      }
      if (meta.BusinessMetadataId === 11) {
        this.emp.chkpersonal = true;
        this.selectedPersonal = meta.EmployeeId;
      }
      if (meta.BusinessMetadataId === 12) {
        this.emp.chkemployment = true;
      }
      if (meta.BusinessMetadataId === 2) {
        this.emp.chkMainSafetyDelegate = true;
        this.selectedMainSafetyDelegate.push(meta.EmployeeId);
      }
      if (meta.BusinessMetadataId === 3) {
        this.emp.chkSafetyDelegate = true;
        this.selectedSafetyDelegate.push(meta.EmployeeId);
      }
      if (meta.BusinessMetadataId === 4) {
        this.emp.chkEmployeeDelegate = true;
        this.selectedEmployeeDelegate.push(meta.EmployeeId);
      }
      if (meta.BusinessMetadataId === 5) {
        this.emp.chkFireDelegate = true;
        this.selectedFireDelegate = meta.EmployeeId;
      }
      if (meta.BusinessMetadataId === 6) {
        this.emp.chkAccountant = true;
        this.selectedAccountant = meta.EmployeeId;
      }
      if (meta.BusinessMetadataId === 7) {
        this.emp.chkAuditor = true;
        this.selectedAuditor = meta.EmployeeId;
      }
      if (meta.BusinessMetadataId === 8) {
        this.emp.chkCompensationInsurance = true;
        this.selectedEmployeeInsurance = meta.WorkmanInsurance;
      }
      if (meta.BusinessMetadataId === 9) {
        this.emp.chkStatutoryInsurance = true;
        this.selectedEmployee = meta.OtpStatutoryInsurance;
      }
      if (meta.BusinessMetadataId === 13) {
        this.emp.chkEnv = true;
        this.selectedEnv = meta.EmployeeId;
      }
    });
  }
  /**
   * multi-select safety delegate
   * @param metaId {any}
   * @param empList {any}
   */
  multiSelectSafetyDelegate(metaId: any, empList: any) {
    let settingMetas: any = [];
    empList.forEach((employeeId: number) => {
      let settingMeta = new SettingsMeta();
      settingMeta.BusinessMetadataId = metaId;
      settingMeta.EmployeeId = employeeId;
      settingMeta.BusinessSettingId = this.settingId;
      settingMetas.push(settingMeta);
    });
    empList = [];
    return settingMetas;
  }

  /**
   * get selected dropdown value and selected checkbox value
   */
  empCheckBoxes() {
    let settingMetas: SettingsMeta[] = [];
    if (this.emp.chkEmployee) {
      let settingMeta = new SettingsMeta();
      settingMeta.BusinessMetadataId = 1;
      settingMeta.EmployeeId = 0;
      settingMetas.push(settingMeta);
    }
    if (this.emp.chkMainSafetyDelegate) {
      settingMetas.push(
        ...this.multiSelectSafetyDelegate(2, this.selectedMainSafetyDelegate)
      );
    }
    if (this.emp.chkSafetyDelegate) {
      settingMetas.push(
        ...this.multiSelectSafetyDelegate(3, this.selectedSafetyDelegate)
      );
    }
    if (this.emp.chkEmployeeDelegate) {
      settingMetas.push(
        ...this.multiSelectSafetyDelegate(4, this.selectedEmployeeDelegate)
      );
    }
    if (this.emp.chkFireDelegate && this.selectedFireDelegate) {
      let settingMeta = new SettingsMeta();
      settingMeta.BusinessMetadataId = 5;
      settingMeta.EmployeeId = this.selectedFireDelegate;
      settingMetas.push(settingMeta);
    }
    if (this.emp.chkAccountant && this.selectedAccountant) {
      let settingMeta = new SettingsMeta();
      settingMeta.BusinessMetadataId = 6;
      settingMeta.EmployeeId = this.selectedAccountant;
      settingMetas.push(settingMeta);
    }
    if (this.emp.chkAuditor && this.selectedAuditor) {
      let settingMeta = new SettingsMeta();
      settingMeta.BusinessMetadataId = 7;
      settingMeta.EmployeeId = this.selectedAuditor;
      settingMetas.push(settingMeta);
    }
    if (this.emp.chkCompensationInsurance) {
      if (this.selectedEmployeeInsurance != '') {
        this.selectedEmpInsurance = true;
        let settingMeta = new SettingsMeta();
        settingMeta.BusinessMetadataId = 8;
        settingMeta.WorkmanInsurance = this.selectedEmployeeInsurance;
        settingMetas.push(settingMeta);
      } else {
        this.selectedEmpInsurance = false;
      }
    }
    if (this.emp.chkCompensationInsurance == false) {
      this.selectedEmpInsurance = true;
    }
    if (this.emp.chkStatutoryInsurance) {
      if (this.selectedEmployee != '') {
        this.selectedEmpstatutory = true;
        let settingMeta = new SettingsMeta();
        settingMeta.BusinessMetadataId = 9;
        settingMeta.OtpStatutoryInsurance = this.selectedEmployee;
        settingMetas.push(settingMeta);
      } else {
        this.selectedEmpstatutory = false;
      }
    }
    if (this.emp.chkStatutoryInsurance == false) {
      this.selectedEmpstatutory = true;
    }
    if (this.emp.chkOccupational) {
      if (this.selectedOccupational != '') {
        this.selectedEmpOccupational = true;
        let settingMeta = new SettingsMeta();
        settingMeta.BusinessMetadataId = 10;
        settingMeta.HealthCare = this.selectedOccupational;
        settingMetas.push(settingMeta);
      } else {
        this.selectedEmpOccupational = false;
      }
    }
    if (this.emp.chkOccupational == false) {
      this.selectedEmpOccupational = true;
    }
    if (this.emp.chkpersonal && this.selectedPersonal) {
      let settingMeta = new SettingsMeta();
      settingMeta.BusinessMetadataId = 11;
      settingMeta.EmployeeId = this.selectedPersonal;
      settingMetas.push(settingMeta);
    }
    if (this.emp.chkemployment) {
      let settingMeta = new SettingsMeta();
      settingMeta.BusinessMetadataId = 12;
      settingMeta.EmployeeId = 0;
      settingMetas.push(settingMeta);
    }
    if (this.emp.chkEnv) {
      let settingMeta = new SettingsMeta();
      settingMeta.BusinessMetadataId = 13;
      settingMeta.EmployeeId = 0;
      settingMetas.push(settingMeta);
    }
    return settingMetas;
  }

  /**
   * add and update business settings
   */
  saveChanges() {
    let businessSetting: BusinessSettingViewDto = new BusinessSettingViewDto();
    businessSetting.SettingsMeta = this.empCheckBoxes();
    this.normalizeResponsibles();

    businessSetting.ResponsibleForExecution =
      this.selectedResponsibleForExecution ?? [];
    businessSetting.ResponsibleForFollowup =
      this.selectedResponsibleForFollowup ?? [];
    businessSetting.ResponsibleForAppraisal =
      this.selectedResponsibleForAppraisals ?? [];
    businessSetting.FlexiCustomerActionPointResponsibleUserId =
      this.selectedFlexiCustomerActionPointResponsibleUserIds[0] ?? null;
    businessSetting.FlexiCustomerActionPointResponsibleUserIds =
      this.selectedFlexiCustomerActionPointResponsibleUserIds ?? [];

    if (
      this.selectedEmpInsurance == true &&
      this.selectedEmpstatutory == true &&
      this.selectedEmpOccupational == true
    ) {
      this.loading = true;
      businessSetting.Id = this.settingId ? this.settingId : 0;
      businessSetting.BusinessId = this.businessId;
      businessSetting.LanguageId = this.selectedLanguage;
      businessSetting.ThemeId = this.selectedTheme;
      businessSetting.InsuranceCompany = this.InsuranceCompany;
      if (this.siteAddress.value.homeSiteAddress) {
        if (this.siteAddress.value.homeSiteAddress.includes('http')) {
          businessSetting.HomePageAddress =
            this.siteAddress.value.homeSiteAddress;
        } else {
          businessSetting.HomePageAddress =
            'http://' + this.siteAddress.value.homeSiteAddress;
        }
      } else {
        businessSetting.HomePageAddress = '';
      }
      businessSetting.HseGoal = this.HseGoals;
      businessSetting.HseFeatureId = this.selectedHseManager;
      businessSetting.HseManagerKey = this.selectedHseManager;
      // HseAdviserKey is not sent: Flexi › Settings owns it.
      businessSetting.EnvironmentallighthouseKey = this.selectedEnvLighthosue;
      businessSetting.BusinessLogo = this.businessLogo;
      businessSetting.BusinessImg = this.businessImage;
      businessSetting.PortalContact = this.selectedPortalContact;

      const responsibleForAppraisalsIsRemoved =
        this.currentResponsibleForAppraisals.filter(
          crfa => !this.selectedResponsibleForAppraisals.includes(crfa)
        );

      if (
        this.hasAppraisalModule &&
        responsibleForAppraisalsIsRemoved.length > 0
      ) {
        this.openConfirmAppraisalRemoval(businessSetting);
      } else {
        this.saveOperation(businessSetting);
      }
    }
  }

  /**
   * Saves the business setting by either updating an existing setting or adding a new one based on the presence of an ID.
   * @param businessSetting Set of business settings to be saved
   */
  saveOperation(businessSetting: BusinessSettingViewDto) {
    // Persist the SDS exposure-register allowlist alongside the business setting so
    // the admin's Editor selection is actually saved on the same "Save" click.
    // Returns of(null) when the section isn't shown (non-admin / no SDS module).
    const exposureAccess$ = this.saveSdsExposureAccessIfNeeded();

    if (businessSetting.Id > 0) {
      this.subscriptions.push(
        forkJoin([
          this.businessSettingService.updateBusinessSetting(businessSetting),
          exposureAccess$
        ]).subscribe({
          next: ([result]: [
            BusinessSettingViewDto,
            SdsExposureAccessDto | null
          ]) => {
            this.applySavedBusinessImages(result);
            this.savedSettingsSnapshot = this.captureSettingsSnapshot();
            this.notifications.success('UI_NOTIFICATIONS.SAVED');
            this.loading = false;
            this.currentResponsibleForAppraisals = structuredClone(
              this.selectedResponsibleForAppraisals
            );
          },
          error: () => {
            this.loading = false;
          }
        })
      );
    } else {
      /* As a safeguard, if no appraisal managers are selected, we set the property to null to avoid sending an
      empty array to the backend, which may remove existing appraisal managers. */
      if (businessSetting.ResponsibleForAppraisal.length === 0) {
        businessSetting.ResponsibleForAppraisal = null;
      }

      this.subscriptions.push(
        forkJoin([
          this.businessSettingService.addSetting(businessSetting),
          exposureAccess$
        ]).subscribe({
          next: ([result]: [any, SdsExposureAccessDto | null]) => {
            this.settingId = result.Id;
            this.applySavedBusinessImages(result);
            this.savedSettingsSnapshot = this.captureSettingsSnapshot();
            this.notifications.success('UI_NOTIFICATIONS.SAVED');
            this.loading = false;
            this.currentResponsibleForAppraisals = structuredClone(
              this.selectedResponsibleForAppraisals
            );
          },
          error: () => {
            this.loading = false;
          }
        })
      );
    }
  }

  private applySavedBusinessImages(result: BusinessSettingViewDto) {
    if (!result) {
      return;
    }

    this.businessLogo = result.BusinessLogo;
    this.businessImage = result.BusinessImg;
  }

  /**
   * Opens a confirmation dialog to confirm the removal of appraisal managers, which will revoke their access.
   * If accepted, it proceeds with saving the business setting; if rejected, it simply stops the loading state.
   * @param businessSetting The business setting that is being saved, which may have appraisal managers removed.
   */
  openConfirmAppraisalRemoval(businessSetting: BusinessSettingViewDto) {
    this.confirmationService.confirm({
      message: this.translate.instant(
        'REMOVE_APPRAISAL_MANAGERS_REVOKE_WARNING_MESSAGE'
      ),
      accept: () => {
        this.saveOperation(businessSetting);
      },
      reject: () => {
        this.loading = false;
      }
    });
  }

  /**
   * get upload url
   * @param url
   * @param callback
   */
  getDataUri(url: any, callback: any) {
    let image = new Image();
    image.onload = function () {
      let canvas = document.createElement('canvas');
      canvas.width = 15; // this.naturalWidth; // or 'width' if you want a special/scaled size
      canvas.height = 15; // this.naturalHeight; // or 'height' if you want a special/scaled size
      canvas.getContext('2d')!.drawImage(url, 0, 0);
      callback(canvas.toDataURL('image/jpg'));
    };
    image.src = url;
  }

  deleteImage(imageType: any) {
    if (imageType != null) {
      this.confirmationService.confirm({
        message: this.translate.instant('DELETE_THIS_RECORD'),
        accept: () => {
          if (imageType == 'Business_Logo') {
            this.businessLogo = null!;
          } else if (imageType == 'Business_Image') {
            this.businessImage = null!;
          }
        }
      });
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub, i) => {
      sub.unsubscribe();
    });
  }
  //#endregion

  /** Read-only list; a failure leaves the rest of the settings usable. */
  private loadHseAdvisors(): void {
    this.hseAdvisorsFailed = false;
    this.subscriptions.push(
      this.flexiAdvisors.businessAdvisors(this.businessId).subscribe({
        next: advisors => (this.hseAdvisors = advisors),
        error: () => {
          this.hseAdvisors = [];
          this.hseAdvisorsFailed = true;
        }
      })
    );
  }
}
